import React, {Suspense} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {createTheme, MuiThemeProvider} from '@material-ui/core/styles';
import SnackBar from './components/snackBarNotification/SnackBarNotification';
import LoginPage from './auth/pages/login/LoginPage';
import ForgotPasswordPage from './auth/pages/forgotPassword/ForgetPassword';
import ResetPassword from './auth/pages/resetPassword/ResetPassword';
import Shared from './shared/shared';
import Spinner from "./components/Spinner/Spinner";
import GenericNotFound from './home/pages/genericNotFound/GenericNotFound';
import Variants from './home/pages/variants/Variants';
import SharedFlow from './shared/sharedFlow';
import './styles/variables.css'
import './assets/i18n';
import './App.css';

function App() {
    return (
        <div className="App">
            <MuiThemeProvider theme={getMuiTheme()}>
                <SnackBar/>
                <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASE || ''}>
                    <Suspense fallback={
                        <div className="loading">
                            <Spinner/>
                        </div>
                    }>
                        <Routes>
                            <Route path="/login" element={<LoginPage/>}/>
                            <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>
                            <Route path="/reset-password/:hash" element={<ResetPassword/>}/>
                            <Route path="/404" element={<GenericNotFound/>}/>)
                            <Route path='automs/:id/*' element={<SharedFlow/>}/>
                            <Route path="/*" element={<Shared/>}/>
                            <Route path="/variants" element={<Variants/>}/>
                        </Routes>
                    </Suspense>
                </BrowserRouter>
            </MuiThemeProvider>
        </div>
    );
}

const getMuiTheme = () => createTheme({
    overrides: {
        MuiToolbar: {
            regular: {
                minHeight: 'unset',
                '@media (min-width: 600px)': {
                    minHeight: 'unset'
                }
            }
        },
        MuiButton: {
            label: {
                textTransform: 'none'
            }
        }
    }
});
export default App;
